import React from 'react';
import { ColumnItem } from '../column-item';
export function Table(props) {
    const { align = 'left', children, padding = '10px 25px', width = '100%', borderCollapse, } = props;
    const collapse = borderCollapse ? { borderCollapse } : {};
    return (React.createElement(ColumnItem, { align: align, padding: padding },
        React.createElement("table", { cellPadding: 0, cellSpacing: 0, width: width.includes('%') ? width : parseInt(width, 10), border: "0", style: {
                color: '#000000',
                fontFamily: 'Ubuntu, Helvetica, Arial, sans-serif',
                fontSize: '13px',
                lineHeight: '22px',
                tableLayout: 'auto',
                width,
                border: 'none',
                ...collapse,
            } }, children)));
}
//# sourceMappingURL=table.js.map